import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import('./views/Login.vue'),
    },
    {
      path: '/changePassword',
      name: 'changePassword',
      component: () => import('./views/ChangePassword.vue'),
    },
    {
      path: '/',
      redirect: '/dashboard',
      component: () => import('./views/Main.vue'),
      children: [
        {
          path: 'dashboard',
          name: 'dashboard',
          component: () => import('./views/Dashboard.vue'),
          meta: { requiresAuth: true },
        },
        {
          path: 'lines',
          name: 'lines',
          component: () => import('./views/QueueManagement.vue'),
          meta: { requiresAuth: true },
        },
        {
          path: 'lines/:type',
          name: 'details',
          component: () => import('./views/QueueManagement.vue'),
          props: true,
          meta: { requiresAuth: true },
        },
        {
          path: 'branches',
          name: 'branches',
          component: () => import('./views/Branches.vue'),
          meta: { requiresAuth: true },
        },
        {
          path: 'forms',
          name: 'forms',
          component: () => import('./views/Form.vue'),
          meta: { requiresAuth: true },
        },
        {
          path: 'extract',
          name: 'extract',
          component: () => import('./views/ExtractData.vue'),
          meta: { requiresAuth: true },
        },
      ],
    },
  ],
});
